import { useEffect, useState } from "react";
import BasicWrapper from "../../components/basicWrapper/basicWrapper";
import ExtendedWrapper from "../../components/extendedWrapper/extendedWrapper";
import { IvnoiceContextProvider } from "../createInvoice/createInvoiceContext";

import { useToaster, Notification, Message } from "rsuite";
import { useTranslation } from "react-i18next";

import "../createInvoice/steps/createInvoice.css"
//
import InvoiceMain from "../createInvoice/steps/1_invoiceMain";
import InvoiceTariff from "../createInvoice/steps/2_tariffPanel";
import InvoiceAdditions from "../createInvoice/steps/3_invoiceAdditions";
import InvoiceResult from "./steps/4_calculateResult"

import InputVoice from "../../components/inputVoice/InputVoice";

import validateForm from "./steps/validators/validatorHelper";
import applyVoice from "../createInvoice/steps/utils/applyVoice";

import { useInvoiceContext } from "../createInvoice/createInvoiceContext";
import { useMessenger } from "../../context/messengerContext";

export default function CalculateInvoiceWrapperExtended({
    invoiceStep, setInvoiceStep,
    maxStep, setMaxStep
}) {
    const { invoiceData, setInvoiceData } = useInvoiceContext();
    const [startTime, setStartTime] = useState(new Date());
    const [ voiceData, setVoiceData ] = useState({});

    const [refresh, setRefresh] = useState(0);

    const { userId, platform } = useMessenger();
    const { t } = useTranslation('basic');

    const toaster = useToaster();

    useEffect(() => {
        console.log(voiceData)
        if (!voiceData || !Object.keys(voiceData).length) return;
        setInvoiceData(d => applyVoice(d, voiceData));
        setRefresh(r => r + 1);
    }, [voiceData]);

    return (
        <>
            <ExtendedWrapper>
                {   
                    invoiceStep === 0 && <InvoiceMain isCalculate /> ||
                    invoiceStep === 1 && <InvoiceTariff /> ||
                    invoiceStep === 2 && <InvoiceAdditions /> ||
                    invoiceStep === 3 && <InvoiceResult startTime={startTime} />
                }
                {
                    invoiceStep != 3 ?
                    <InputVoice onNavigateForward={() => {
                        let errors = validateForm(invoiceStep, invoiceData)
                        
                        setInvoiceData({...invoiceData, errors});
                        console.log(errors);
                        if (Object.keys(errors).length) {
                            toaster.push(<Message type="error" showIcon>{t('not_all_required_fields_filled')}</Message>, { placement: "topCenter", duration: 3000 });

                            for (let key in errors) {
                                if (key.includes("places")) {
                                    if (errors[key].length == "place_length_invalid_error" ||
                                        errors[key].height == "place_height_invalid_error" ||
                                        errors[key].width == "place_width_invalid_error"
                                    ) {
                                        toaster.push(
                                        <Message type="error" showIcon>
                                            {t('place_size_out_of_bounds', { number: parseInt(key.split('.')[1]) + 1 })}
                                        </Message>, { placement: "topCenter", duration: 3000 });
                                    }
                                }
                            }

                            return;
                        };


                        setInvoiceStep(Math.min(3, invoiceStep + 1));
                    }} ml_page={"prepare_invoice_calculate"} setJsonForm={setVoiceData}/>
                    : null
                }
            </ExtendedWrapper>
        </>
    )
}